/** Длина неизменяемого префикса «+7 (» — курсор ввода только справа от него */
const PHONE_PREFIX_LEN = 4;

const MATRIX = '+7 (___) ___-__-__';
const DEF = MATRIX.replace(/\D/g, '');

/**
 * @param {string} raw
 * @returns {string} до 11 цифр: ведущая 7, 9… → 79…, 8… → 7…
 */
function normalizeValDigits(raw) {
    let v = String(raw || '').replace(/\D/g, '');
    if (!v.length) return '';
    if (v.length > 11) v = v.slice(0, 11);
    if (v[0] === '8') v = '7' + v.slice(1);
    if (v.length <= 10 && v[0] === '9') v = '7' + v;
    while (v.length && v[0] !== '7') v = v.slice(1);
    return v.slice(0, 11);
}

function formatPhoneValue(val) {
    let i = 0;
    let newValue = MATRIX.replace(/[_\d]/g, (a) => {
        return i < val.length ? val.charAt(i++) || DEF.charAt(i) : a;
    });
    i = newValue.indexOf('_');
    if (i !== -1) {
        newValue = newValue.slice(0, i);
    }
    return newValue;
}

/** Позиция курсора сразу после n-й цифры в отформатированной строке */
function cursorAfterNthDigit(newValue, n) {
    if (n <= 0) return PHONE_PREFIX_LEN;
    let c = 0;
    for (let j = 0; j < newValue.length; j++) {
        if (/\d/.test(newValue[j])) {
            c++;
            if (c === n) return Math.max(PHONE_PREFIX_LEN, j + 1);
        }
    }
    return Math.max(PHONE_PREFIX_LEN, newValue.length);
}

function clampSelectionToPrefix(el) {
    const len = el.value.length;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const p = Math.min(PHONE_PREFIX_LEN, len);
    if (start < PHONE_PREFIX_LEN || end < PHONE_PREFIX_LEN) {
        if (end <= PHONE_PREFIX_LEN) {
            el.setSelectionRange(p, p);
        } else {
            el.setSelectionRange(p, Math.max(p, end));
        }
    }
}

function applyValueAndSync(el, valDigits, cursorDigitCount) {
    const newValue = formatPhoneValue(valDigits);
    el.value = newValue;
    const pos = cursorAfterNthDigit(newValue, cursorDigitCount);
    el.setSelectionRange(pos, pos);
    el.dispatchEvent(new Event('input', { bubbles: true }));
}

export default {
    mounted(el) {
        const mask = function (event) {
            // Синтетический input (ниже) нужен только чтобы v-model подхватил значение
            // после форматирования маской; саму маску на нём не гоняем.
            if (event.type === 'input' && event.isTrusted === false) {
                return;
            }

            const start = el.selectionStart;

            let val = normalizeValDigits(el.value);

            const valueBeforeCursor = el.value.substring(0, start);
            const digitsBeforeCursor = valueBeforeCursor.replace(/\D/g, '').length;

            let newValue = formatPhoneValue(val);

            el.value = newValue;

            if (event.type === 'input') {
                let newCursorPos = 0;
                let digitCount = 0;

                for (let j = 0; j < newValue.length; j++) {
                    if (/\d/.test(newValue[j])) {
                        digitCount++;
                    }
                    if (digitCount > digitsBeforeCursor) {
                        break;
                    }
                    newCursorPos = j + 1;
                }

                newCursorPos = Math.max(PHONE_PREFIX_LEN, newCursorPos);
                newCursorPos = Math.min(newCursorPos, newValue.length);

                setTimeout(() => {
                    el.setSelectionRange(newCursorPos, newCursorPos);
                }, 0);

                // Vue 3 может обработать v-model раньше маски; тогда в модели остаётся «сырое»
                // значение, а в DOM — уже +7 (…). Повторный input после формата синхронизирует модель.
                queueMicrotask(() => {
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                });
            }

            if (event.type === 'focus') {
                setTimeout(() => clampSelectionToPrefix(el), 0);
            }
        };

        const handleKeydown = function (event) {
            if (event.key === 'Home') {
                event.preventDefault();
                el.setSelectionRange(
                    Math.min(PHONE_PREFIX_LEN, el.value.length),
                    Math.min(PHONE_PREFIX_LEN, el.value.length)
                );
                return;
            }

            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                const pos = el.selectionStart;
                if (pos <= PHONE_PREFIX_LEN) {
                    event.preventDefault();
                    el.setSelectionRange(PHONE_PREFIX_LEN, PHONE_PREFIX_LEN);
                }
            }

            if (event.key === 'Backspace' || event.key === 'Delete') {
                let pos = el.selectionStart;
                if (event.key === 'Backspace' && pos > 0 && pos < PHONE_PREFIX_LEN) {
                    event.preventDefault();
                    el.setSelectionRange(Math.min(PHONE_PREFIX_LEN, el.value.length), Math.min(PHONE_PREFIX_LEN, el.value.length));
                    return;
                }
                if (pos > 0 && event.key === 'Backspace' && /[\s()-]/.test(el.value.charAt(pos - 1))) {
                    event.preventDefault();
                    let newPos = pos - 1;
                    while (newPos > 0 && /[\s()-]/.test(el.value.charAt(newPos - 1))) {
                        newPos--;
                    }
                    el.setSelectionRange(newPos, newPos);
                } else if (event.key === 'Delete' && /[\s()-]/.test(el.value.charAt(pos))) {
                    event.preventDefault();
                    let newPos = pos + 1;
                    while (newPos < el.value.length && /[\s()-]/.test(el.value.charAt(newPos))) {
                        newPos++;
                    }
                    el.setSelectionRange(newPos, newPos);
                }
            }

            if (
                event.key.length === 1 &&
                /\d/.test(event.key) &&
                !event.metaKey &&
                !event.ctrlKey &&
                !event.altKey
            ) {
                const s = el.selectionStart;
                const e = el.selectionEnd;
                if (s === e && s < PHONE_PREFIX_LEN) {
                    event.preventDefault();
                    let digits = normalizeValDigits(el.value);
                    if (digits.length >= 11) {
                        el.setSelectionRange(PHONE_PREFIX_LEN, el.value.length);
                        return;
                    }
                    digits = normalizeValDigits(digits + event.key);
                    applyValueAndSync(el, digits, digits.length);
                }
            }
        };

        const handleClick = function () {
            setTimeout(() => clampSelectionToPrefix(el), 0);
        };

        const handlePaste = function (event) {
            event.preventDefault();
            const text = (event.clipboardData || window.clipboardData).getData('text');
            const digits = normalizeValDigits(text);
            applyValueAndSync(el, digits, digits.length);
        };

        el._maskHandler = mask;
        el._keydownHandler = handleKeydown;
        el._clickHandler = handleClick;
        el._pasteHandler = handlePaste;

        el.addEventListener('input', el._maskHandler, false);
        el.addEventListener('focus', el._maskHandler, false);
        el.addEventListener('blur', el._maskHandler, false);
        el.addEventListener('keydown', el._keydownHandler, false);
        el.addEventListener('click', el._clickHandler, false);
        el.addEventListener('paste', el._pasteHandler, false);

        if (el.value) {
            mask({ type: 'focus' });
        }
    },

    unmounted(el) {
        el.removeEventListener('input', el._maskHandler);
        el.removeEventListener('focus', el._maskHandler);
        el.removeEventListener('blur', el._maskHandler);
        el.removeEventListener('keydown', el._keydownHandler);
        el.removeEventListener('click', el._clickHandler);
        el.removeEventListener('paste', el._pasteHandler);
    },
};
